import { Link } from 'react-router-dom';
import { getArticleHighlights } from '@/mocks/articles';

export default function ArticleHighlights() {
  const highlightArticles = getArticleHighlights();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            SEO Articles
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Sugargoo Spreadsheet{' '}
            <span className="text-primary-600 italic">Resources &amp; Guides</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Explore our collection of in-depth articles covering everything you need to know about Sugargoo — from reviews and shipping guides to money-saving tips and safety analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {highlightArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-100 rounded-2xl border border-background-200/70 hover:border-accent-200 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    {article.badge}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readingTime}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.metaDescription}
                </p>
                <div className="mt-auto flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  Read Article
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}